import api from '@/api'
import moment from 'moment'

const state = {
  factoryName: '',
  machineId: '',
  startDate: new Date(),
  endDate: new Date(),
  limit: 50,
  page: 1,

  searchText: '',

  tarList: [],
  totalCount: 0,

  factories: [],

  // search param
  myLabellingStatus: '',
  reviewStatus: '',
  machineStatus: '',
}

const getters = {
  filteredTarList(state) {
    return state.tarList.filter(tar => {
      const searchStr = [
        tar.detectionMachineId,
        tar.factoryName,
        JSON.stringify(tar.labelStat),
        tar.machineAlias,
        tar.machineStatus,
        tar.ossPath,
        tar.tarId,
        tar.uploadedTimeInt64,
      ].join(' ')
      return new RegExp(state.searchText, 'i').test(searchStr)
    })
  },
}

const mutations = {
  setTarList(state, tarList) {
    state.tarList = tarList
  },
  setTotalCount(state, totalCount) {
    state.totalCount = totalCount
  },
  setFactories(state, factories) {
    state.factories = factories
  },
}

const actions = {
  fetchFactory({ commit }) {
    api.getFactory().then(({ data }) => {
      commit('setFactories', data.factories)
    })
  },
  fetchTarList({ state, commit, rootState }, mode = 'label') {
    // set machineID
    let detectionMachineId = state.machineId
    if (state.machineId) {
      const isMacAddr = /^[0-9a-fA-F]{2}(-[0-9a-fA-F]{2}){5}$/.test(
        state.machineId,
      )
      if (isMacAddr) {
      } else {
        // is alias
        const aliasItem = rootState.alias.find(
          item => item.alias === state.machineId,
        )
        if (aliasItem) {
          detectionMachineId = aliasItem.id
        } else {
          detectionMachineId = ''
        }
      }
    }
    const params = {
      factoryName: state.factoryName,
      detectionMachineId,
      fromDate: moment(state.startDate).format('YYYYMMDD'),
      toDate: moment(state.endDate).format('YYYYMMDD'),
      pageId: state.page - 1,
      limit: state.limit,
      myLabellingStatus: state.myLabellingStatus,
      machineStatus: state.machineStatus,
    }
    if (mode === 'label') {
    } else {
      params.reviewStatus = state.reviewStatus
    }
    return new Promise((resolve, reject) => {
      api
        .getTarList(params)
        .then(({ data }) => {
          commit('setTarList', data.tars)
          commit('setTotalCount', data.totalCount)
          resolve()
        })
        .catch(reject)
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
